<template>
  <Content @back="$router.back()" key="exportsList">
    <template v-slot:nav_left>
      <p>专家管理</p>
    </template>
    <template v-slot:nav_right>
      <div class="yioks_btn" @click="handleEmptyAction">新增专家</div>
    </template>
    <template v-slot:content_right>
      <div class="base-content-warpper">
        <div class="content-inner-wrapper">
          <div class="select_wrap">
            <div class="select_box left">
              <!-- <el-select
                v-model="filterData.jixiaoType"
                class="y-input"
                clearable
                placeholder=""
                @change="changeQuery(true)"
              >
                <el-option label="全部指标类型" value=""></el-option>
                <el-option
                  v-for="item in performanceGroupTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            </div>
            <div class="select_box right">
              <input
                v-model.trim="filterData.key"
                type="text"
                class="yioks_input"
                style="width: 160px"
                placeholder="请输入关键字"
                @keyup.enter="changeQuery(true)"
              />
              <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
            </div>
          </div>

          <div class="list_wrap" v-if="!isShowPageLoading && pageList.length">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th seq">序号</div>
                  <div class="th idName">姓名</div>
                  <div class="th gender">性别</div>
                  <div class="th phone">手机号</div>
                  <div class="th idNumber">身份证号</div>
                  <div class="th userStatus">状态</div>
                  <div class="th intro">备注</div>
                  <div class="th action">操作</div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        class="tr"
                        v-for="(item, index) in pageList"
                        :key="index"
                      >
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <div class="td idName">
                          <p>{{ item.idName }}</p>
                        </div>
                        <div class="td gender">
                          <p>{{ item.gender }}</p>
                        </div>
                        <div class="td phone">
                          <p>{{ item.phone | hidePhone }}</p>
                        </div>
                        <div class="td idNumber">
                          <p>{{ item.idNumber | hideIdNumber }}</p>
                        </div>
                        <div class="td userStatus">
                          <p>{{ item.userStatus | filterUserStatus }}</p>
                        </div>
                        <div class="td intro">
                          <p>{{ item.intro }}</p>
                        </div>
                        <div class="td action">
                          <span class="item active" @click="handleEditRow(item)">编辑</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>
          <yioks-loading v-if="isShowPageLoading" />

          <yioks-empty
            v-if="!isShowPageLoading && !pageList.length"
            tips="暂时没有数据，"
            name="点击添加专家"
            @callback="handleEmptyAction"
          ></yioks-empty>
        </div>
      </div>
      <yioks-pagination :page.sync="page" :total="total"></yioks-pagination>
      <template v-if="isShowExpertAction">
        <expert-action
          :isShow.sync="isShowExpertAction"
          :isEdit="isEditExpert"
          :defaultInfo="editRow"
          @callback="expertActionCallback"
        >
        </expert-action>
      </template>
    </template>
  </Content>
</template>

<script>
import { getExpertPage } from "@/api/export/index";
import { filterUserStatus } from "@/utils/yioks_filter";

export default {
  components: {
    Content: () => import("@/components/layout/list"),
    "yioks-tips": () => import("@/components/YioksTip"),
    "expert-action": () =>
      import("@/views/export/expertManagement/ExpertAction"),
  },

  data() {
    return {
      filterData: {
        key: "",
        stageUuid: '',
      },
      pageList: [],

      page: 0,
      pageSize: 20,
      total: 0,

      isShowPageLoading: false,

      isShowExpertAction: false,

      isEditExpert: false,
      editRow: {},
    };
  },

  computed: {
    phaseUuid() {
      const { phaseUuid } = this.$route.query;
      return phaseUuid || "";
    },
  },

  filters: {
    filterUserStatus,
    hideIdNumber(idNumber) {
      if (!idNumber) return '';
      // 隐藏身份证号后四位
      return idNumber.replace(/(.{14})(.{4})$/, '$1****');
    },
    hidePhone(phone) {
      if (!phone) return '';
      // 隐藏手机号后四位
      return phone.replace(/(\d{7})\d{4}/, '$1****');
    }
  },

  watch: {
    page() {
      this.changeQuery();
    },
    isShowExpertAction(val) {
      if(!val) {
        this.isEditExpert = false;
        this.editRow = {}
      }
    },
  },

  created() {
    this.setFilterData();
    this.changeQuery(true);
  },

  methods: {
    handleEmptyAction() {
      this.isShowExpertAction = true;
    },

    // 弹窗回调 actionStatus弹窗按钮状态； funStatus弹窗操作结果回调
    expertActionCallback(actionStatus, funStatus) {
      if (actionStatus) {
        if (funStatus) {
          this.changeQuery(true);
        }
      }
      this.isEditExpert = false;
      this.isShowExpertAction = false;
      this.editRow = {}
    },

    // 设置参数
    setFilterData() {
      const { page } =
        this.$route.query;
      if (page) this.page = page;

    },

    // 预设方法
    changeQuery(flag) {
      flag && (this.page = 0);
      this.$router.replace({
        path: this.$route.fullpath,
        query: {
          ...this.$route.query,
          ...this.filterData,
          page: this.page,
        },
      });
      this.loadPageList();
    },

    // 加载列表请求方法
    loadPageList(flag = false) {
      // const { stageUuid } = this.$route.query;
      const paramsData = {
        page: this.page,
        size: this.pageSize,
        ...this.filterData
      };

      if (!flag) this.isShowPageLoading = true;
      let requestName = getExpertPage;

      if (requestName) {
        requestName(paramsData)
          .then((res) => {
            if (!flag) this.isShowPageLoading = false;
            if (res.code) {
              this.$msssage.error(res.msg);
              return;
            }
            const { content, totalElements } = res;
            this.total = totalElements;
            this.pageList = content;
          })
          .catch((err) => {
            this.isShowPageLoading = false;
            console.error("err", err);
          });
      } else {
        console.error("user type select error");
      }
    },

    handleEditRow(row) {
      this.editRow = row;
      this.isEditExpert = true;
      this.isShowExpertAction = true;
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/yioks_page_table'
.seq
  width 5%
.idName
  width 15%
.gender
  width 6%
.phone
  width 14%
.userStatus
  width 6%
.intro
  width 22%
.idNumber
  width 23%
.action
  // width 16%
  flex 1
  .item
    cursor pointer
    user-select none
    &.active
      color $green_color
    &.danger
      color $red_color
</style>
